module.exports = __webpack_public_path__ + "img/f1ec4cb.jpg";